import Cookies from 'js-cookie';

const TokenKey = 'Admin-Token';
const ActiveWebsite = 'Active_website';
export function getToken() {
    return Cookies.get(TokenKey);
}
export function setActiveWebsite(id) {
    return Cookies.set(ActiveWebsite, id);
}
export function getActiveWebsite() {
    return Cookies.get(ActiveWebsite);
}
export function setToken(token) {
    return Cookies.set(TokenKey, token);
}

export function removeToken() {
    return Cookies.remove(TokenKey);
}

export function setTutorial() {
    return Cookies.set('tutorial', 'value', { expires: 367 })
}
export function hasTutorial() {
    return Cookies.get('tutorial');
}
